<template>
  <div
    class="relative flex cursor-pointer"
    @click="selectable && (modelValue = type)"
  >
    <span
      class="w-full f-col gap-1 bg-grey-90 py-4 text-sm"
      :class="[{ 'mb-4': !selectable }, !selectable ? 'rounded-lg px-4' : type === 'standard' ? 'rounded-t-lg' : 'rounded-b-lg']"
    >
      <component
        :is="selectable ? VfRadio : BaseRadio"
        v-model="modelValue"
        :aria-describedby="[type === 'pickup' ? pickupStoreId : '', descriptionId].join(' ')"
        class="o:static"
        :name="type"
        :value="type"
        @change="$emit('change', $event)"
      >
        <span class="body-1 fw-bold peer-focus-visible:outline-auto">
          {{ label }}
        </span>
        <span v-if="type === 'standard'" :id="descriptionId" class="mt-1 caption-1 c-grey-40">
          <span class="block f-col gap-1">
            <product-shipping-methods-estimated-delivery v-if="showEdd && variant?.buyable" :variant />
            <template v-else>
              <span>
                {{ $t.standardShipping }}
              </span>
              <span v-if="description">
                {{ description }}
              </span>
            </template>
          </span>
        </span>
        <template v-else-if="type === 'pickup'">
          <span class="caption-1 c-grey-40 children:block">
            <span v-if="selectedStore" :id="pickupStoreId">
              {{ selectedStore.name }}
            </span>
            <base-button class="relative z-1 self-start underlined" @click.stop="$emit('open-search')">
              {{ selectedStore ? $t.changeStore.title : $t.findStore }}
            </base-button>
            <span v-if="description" :id="descriptionId" class="mt-2" :class="{ 'c-red-30': error }">
              {{ description }}.
            </span>
          </span>
        </template>
      </component>
    </span>
  </div>
</template>

<script lang="ts" setup>
import type { LocatorSearchItem } from '#types/brandify'
import type { SelectedVariant } from '#types/product'
import { BaseRadio, VfRadio } from '#components'

declare global {
  interface Window {
    narvar: (targetElement: string, config: object) => void
  }
}

const { selectable = true, type = 'standard' } = defineProps<{
  description?: string
  error?: boolean
  label: string
  selectable?: boolean
  selectedStore?: LocatorSearchItem
  showEdd?: boolean
  type?: 'standard' | 'pickup'
  variant?: SelectedVariant
}>()

defineEmits<{
  'change': [value: string]
  'open-search': []
}>()

const modelValue = defineModel<string>()
const id = useId()
const descriptionId = `shipping-method-${type}-description-${id}`
const pickupStoreId = `shipping-method-pickup-store-${id}`
</script>
